export const CHANGELOGINSTATE = 'changeLoginState'
export const CHANGESCREENWIDTH = 'changeScreenWidth'
export const CHANGECUSTOMINDEX = 'changeCustomIndex'
export const CHANGEORDER = 'changeOrder'
export const CHANGELOGINMESS = 'changeLoginMess'
export const NETWORKCHAGE = 'networkChage'
export const CLEARMESS = 'clearMess'
